import { TermsPage } from '@/pages/terms';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/terms')({
	component: TermsPage,
});
